import { SharedTypes } from '@semios/app-platform-banyan-route-definitions'

export enum TNodeStatus {
  PLANNED = 'planned',
  ACTIVE = 'active',
  ERROR = 'error',
  OFFLINE = 'offline',
  PENDING = 'pending',
  REMOVED = 'removed',
}

export const ConsumableType = SharedTypes.ServiceCenter.ConsumableType

export type AnyNode =
  | SharedTypes.ServiceCenter.TPlannedNode
  | SharedTypes.ServiceCenter.TPlannedGateway
  | SharedTypes.ServiceCenter.TActiveNode
  | SharedTypes.ServiceCenter.TActiveGateway

export type TPlannedNode = SharedTypes.ServiceCenter.TPlannedNode

export type TPlannedGateway = SharedTypes.ServiceCenter.TPlannedGateway

export type TActiveNode = SharedTypes.ServiceCenter.TActiveNode

export type TActiveGateway = SharedTypes.ServiceCenter.TActiveGateway

export type TDevice = SharedTypes.ServiceCenter.TDevice

export type TNodeDevice = SharedTypes.ServiceCenter.TNodeDevice

export type TNodeConsumablesStatus = SharedTypes.ServiceCenter.TNodeConsumablesStatus

export type TNodeLures = SharedTypes.ServiceCenter.TNodeLures

export type TNodeTrap = SharedTypes.ServiceCenter.TNodeTrap

export type TNodeConsumablesStatusGetParams = SharedTypes.ServiceCenter.GetNodeConsumablesStatusRequest & {
  propertyId: number
}

export type TNodeDevices = SharedTypes.ServiceCenter.TNodeDevices

export type TNodeDevicePort = SharedTypes.ServiceCenter.TNodeDevicePort

export const NodeDevicePort = SharedTypes.ServiceCenter.NodeDevicePort

export type TNodeDeviceChannels = SharedTypes.ServiceCenter.TNodeDeviceChannels

export type TNodeType = SharedTypes.ServiceCenter.TNodeType

export type TNodeLog = SharedTypes.ServiceCenter.TNodeLog

export type TSnNodeLog = SharedTypes.ServiceCenter.TSnNodeLog

export type TDnNodeLog = SharedTypes.ServiceCenter.TDnNodeLog

export type TLnNodeLog = SharedTypes.ServiceCenter.TLnNodeLog

export type TLnSCDLog = SharedTypes.ServiceCenter.TLnSCDLog

export type TDeviceLog = SharedTypes.ServiceCenter.TDeviceLog

export type TManagementTypes = SharedTypes.ServiceCenter.ManagementTypes

export const ManagementTypes = SharedTypes.ServiceCenter.ManagementTypes

export const NodeDeviceInstallationStatus = SharedTypes.ServiceCenter.NodeDeviceInstallationStatus

export type TOnboardLog = SharedTypes.ServiceCenter.TOnboardLog

export enum InstallationStep {
  LOCATION_CONFIRMATION = 'LOCATION_CONFIRMATION',
  OVERVIEW = 'OVERVIEW',
  NODE_ACTIVATION = 'NODE_ACTIVATION',
  DEVICES_INSTALLATION = 'DEVICES_INSTALLATION',
  CHECKLIST = 'CHECKLIST',
  REVIEW = 'REVIEW',
  NODE_CONFIGURATION = 'NODE_CONFIGURATION',
}

type TInstallationStep = {
  type: InstallationStep
  title: string
  enabled: boolean
  completed: boolean
  required: boolean
}

export type TEquipmentInstallationStep = TInstallationStep

export type TNodeServiceIssueSummary = SharedTypes.ServiceCenter.TNodeServiceIssueSummary

export type TNodeServiceIssueDetail = SharedTypes.ServiceCenter.TNodeServiceIssueDetail

export type TResolutionType = SharedTypes.ServiceCenter.TResolutionType

// eslint-disable-next-line no-redeclare
export const TResolutionType = SharedTypes.ServiceCenter.TResolutionType

export type TServiceIssueStatus = SharedTypes.ServiceCenter.TServiceIssueStatus

// eslint-disable-next-line no-redeclare
export const TServiceIssueStatus = SharedTypes.ServiceCenter.TServiceIssueStatus

export type TResolutionActionActual = SharedTypes.ServiceCenter.TResolutionActionActual

export type TServiceIssueResolutionAction = SharedTypes.ServiceCenter.TResolutionAction

export type TPropertyEquipmentSummary = {
  propertyId: number
  onlineNodesCount: number
  offlineNodesCount: number
  errorNodesCount: number
  plannedNodesCount: number
}

export type TLures = SharedTypes.ServiceCenter.TLures

export type TLure = SharedTypes.ServiceCenter.TLure
